export enum ErrorMessage {
  DisactivatedAccount = "BlockedAccount",
  InvalidCredentials = "InvalidCredentials",
  UserAlreadyExists = "UserAlreadyExists",
  SecretsNotFound = "SecretsNotFound",
  OAuthUser = "OAuthUser",
  InvalidResetToken = "InvalidResetToken",
  InvalidVerificationToken = "InvalidVerificationToken",
  EmailAlreadyVerified = "EmailAlreadyVerified",
  TwoFactorNotEnabled = "TwoFactorNotEnabled",
  TwoFactorAlreadyEnabled = "TwoFactorAlreadyEnabled",
  InvalidTwoFactorCode = "InvalidTwoFactorCode",
  InvalidTwoFactorBackupCode = "InvalidTwoFactorBackupCode",
  InvalidBrowserConnection = "InvalidBrowserConnection",
  ResumeSlugAlreadyExists = "ResumeSlugAlreadyExists",
  ResumeNotFound = "ResumeNotFound",
  ResumeLocked = "ResumeLocked",
  ResumePrinterError = "ResumePrinterError",
  ResumePreviewError = "ResumePreviewError",
  SomethingWentWrong = "SomethingWentWrong",
  AdminAuthorizationError = "OnlyAdminAdminAction",
  ItemNotFoundError = "ObjectNotFound",
  RateAlreadyExists = "RateAlreadyExists",
  InvalidPromoUser = "OnlyForPromoUser",
  PromoTypeWithoutPromoUserError = "PromoTypeOnlyWithPromoUser",
  ReductionTypeWithoutRateError = "ReductionTypeOnlyWithRate",
  InvalidCoupon = "CouponDoNotHaveUserAndRate",
  NoIdempotencyKeyForPayment = "NoIdempotencyKeyForPayment",
  InvalidResumeLanguage = "InvalidResumeLanguage",
  RequiredResumeAndJobDesc = "RequiredResumeAndJobDesc",
  MinimalAmountWithdrawal = "MinimalAmountWithdrawal",
  CreditBalanceNotSufficient = "CreditBalanceNotSufficient",
  PromoCreditExpired = "PromoCreditExpired",
  UnaivablePaymentProvider = "UnaivablePaymentProvider",
  DecisonWithdrawalHasAlreadyMade = "DecisonWithdrawalHasAlreadyMade",
  ResumeCantBeEdited = "ResumeCantBeEdited",
}
